/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Observation_Ids_Not_PendingInputs */

const es_co2_error_observation_ids_not_pending = /** @type {(inputs: Error_Observation_Ids_Not_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una de las observaciones seleccionadas ya no está abierta y pendiente.`)
};

/**

* @param {Error_Observation_Ids_Not_PendingInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_observation_ids_not_pending = /** @type {((inputs?: Error_Observation_Ids_Not_PendingInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Observation_Ids_Not_PendingInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_observation_ids_not_pending(inputs)
});